<template>
    <div class="documents-page">
        <documents-menu 
            :document-data="documentData"
        />
        <documents 
            :document-data="documentData"
            :documentable-id="documentableId"
            :documentable-type="documentableType"
            :show-view-toggle="true"
            default-view-mode="grid"
        />
    </div>
</template>

<script>
import DocumentsMenu from './DocumentsMenu.vue';
import Documents from './Documents.vue';

export default {
    name: 'DocumentsPage',
    
    components: {
        DocumentsMenu,
        Documents
    },

    props: {
        documentData: {
            type: Array,
            default: () => []
        },
        documentableId: {
            type: Number,
            required: true
        },
        documentableType: {
            type: String,
            required: true
        }
    }
};
</script>
